import React from "react";

import { Button } from "../../../components/buttons";
import H3Text from "../../../components/components-text/h3-text";
import HeadText from "../../../components/components-text/head-text";
import { StatsCardContainer } from "./stats-card-style";

interface StatsCardProps {
  title?: string;
  stats: number | string;
  actionText: string;
  privilege: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

const StatsCard = ({
  title = "",
  stats,
  actionText,
  privilege,
  children,
  onClick,
}: StatsCardProps) => {
  return (
    <StatsCardContainer>
      <div className="stats-card-title">
        <H3Text>
          <p>{title}</p>
        </H3Text>
      </div>
      <div className="stats-card-content">
        <div className="stats-card-content-number">
          <p>{stats}</p>
        </div>
        <div className="stats-card-content-text">
          <HeadText>{children}</HeadText>
        </div>
        {privilege && (
          <div className="stats-card-content-action">
            <Button text={actionText} onClick={onClick} />
          </div>
        )}
      </div>
    </StatsCardContainer>
  );
};

export default StatsCard;
